export const formatUrl = (slug, prefix) => {
  if (prefix) {
    return `/${prefix}/${slug}`;
  } else {
    return `/${slug}`;
  }
};
export default formatUrl;
